<template>
	<div class="type">
		<div class="FilesAndPicturesBox" v-if="PicturesTypeData != null">
			<FilesAndPictures class="FilesAndPictures" :DelFlag="false" v-for="(item , index) of PicturesTypeData"
				:key="index" :fileAddImgData="item" @See="See"></FilesAndPictures>
		</div>
	</div>
</template>

<script>
	import FilesAndPictures from '@/components/FilesAndPictures.vue'
	export default {
		components: {
			FilesAndPictures
		},
		props: {
			PicturesTypeData: {
				type: Array
			},
			typeTitle: {
				type: String
			}
		},
		data() {
			return {}
		},
		created() {},
		mounted() {},
		activated() {},
		updated() {},
		methods: {
			imgShowClick(par) {
				this.$emit('imgShowClick', par)
			},
			See(par) {
				this.$emit('See', par)
			}
		},
		computed: {},
		watch: {},
	}
</script>
<style scoped lang='less'>
	.FilesAndPicturesBox {
		width: 101%;
		// height: 500px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.FilesAndPictures {
		margin-left: 20px;
	}
</style>